<template> 
  <div class="router-front"></div>
  <div class="router">
  
  <router-view v-slot="{ Component, route }">
  <transition name="fade" mode="out-in">
    <component :is="Component" :key="route.path" />
  </transition>
</router-view>
  </div> 
  <div  class="router-backend"></div>
  </template>
  <script setup>
  import {reactive,provide,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
  import * as vueUse from "@vueuse/core";
  import Language from "@/hooks/language.js";
  import Router from "@/hooks/router.js";
  import bridge from "@/utils/sdkBridge.js";
  import * as request from "@/api/request";
  import * as utils from "@/utils";
  import * as _ from "lodash-es";
  import { useRoute } from 'vue-router';
 

 const route = useRoute();
      const { initLang ,curLang, getLangTxt, langData} = Language();

      const routerData = {};
      const compData = {};
      const PAGE_DATA_LANG = {"default":{"isLogin":false,"host":utils.getMainHost(),"pageId":"zz_musdarkglobal","isDownloadExe":true,"abTestVersion":"","gameId":390,"curBgUrl":``},"en-US":{"isLogin":false,"host":utils.getMainHost(),"pageId":"zz_musdarkglobal","isDownloadExe":true,"abTestVersion":"","gameId":390,"curBgUrl":``}};
      const pageData = reactive(PAGE_DATA_LANG[curLang] || PAGE_DATA_LANG['en-US']||{});
      let pagePlatform = "global"
      let pagePlatformId = 8;

      provide("pageData", pageData);

      if(pageData.gameId!==void 0 ){
        pageData.gameId = utils.getUrlParams("gameId") ||  utils.getUrlParams("gameID") ||  utils.getUrlParams("game_id") || pageData.gameId || ""
      }

      initLang();
      // 自定义setup - 开始
      pageData.gameId =
  utils.getUrlParams("gameId") ||
  utils.getUrlParams("gameID") ||
  utils.getUrlParams("game_id") ||
  pageData.gameId
pageData.isDownloadExe = false

const country = ref("")

const getIpInfo = async () => {
  let res = await request.getJSON("//gstore.endomainname.com/test_ip")
  return res
}

const materialPackageInfo = computed(() => {
  let pagePackageCode = "";
  let pageFileCode = "";

  try {
    let url = new URL(pageData.curBgUrl);
    pagePackageCode = url.searchParams.get("p_id") || "";
    pageFileCode = url.searchParams.get("f_id") || "";
  } catch (error) {}

  return {
    pagePackageCode,
    pageFileCode
  }
})

const zzyPoint = async (eventName) => {
  window.zzDataLayer.push({
    platformId: pagePlatformId,
    gameId: pageData.gameId,
    aid: pageData.pageId,
    pagePackageCode: materialPackageInfo?.value?.pagePackageCode || '',
    pageFileCode: materialPackageInfo?.value?.pageFileCode || '',
    abTestBg: pageData.abTestVersion,
    abTestBtns: "",
    eventName
  });
}
provide("zzyPoint", zzyPoint)

const gaClickUpload = (event) => {
  try {
    window.dataLayer.push({
      event,
      aid: pageData.pageId,
      ab_test_version: pageData.abTestVersion,
      device: utils.systemType(),
    })
  } catch (e) {}
}

provide("gaClickUpload", gaClickUpload)

watch(
  () => pageData.abTestVersion,
  (value) => {
    if (value) {
      gaClickUpload("gtm-visit");
      zzyPoint();
    }
  }
)

const getCurLinkFromParams = (link, paramsArr = []) => {
  let realLink = ""
  try {
    realLink = new URL(link)
  } catch (e) {}
  if (!realLink) return link
  paramsArr.forEach((item) => {
    realLink.searchParams.set(item, utils.getUrlParams(item))
  })
  return realLink.href
}

provide("getCurLinkFromParams", getCurLinkFromParams)

const getExtraParams = () => {
  let fbc = utils.getCookie('_fbc')
  if (!fbc) {
    let fbclid = utils.getUrlParams("fbclid")
    fbc = fbclid ? `fb.1.${new Date().getTime()}.${fbclid}` : ""
    utils.setCookie(`_fbc`, fbc, 30)
  };
  let fbp = utils.getCookie('_fbp')
  let adid = utils.getUrlParams("adid");
  let camid = utils.getUrlParams("camid");
  let adsetid = utils.getUrlParams("adsetid");
  return {
    fbc,
    fbp,
    adid,
    camid,
    adsetid
  }
}
provide("getExtraParams", getExtraParams)
      // 自定义setup - 结束


  </script>
  <style lang="scss">
    @import 'assets/common.scss';

    #app {
  height: 100%;
  width: 100%;
}

body,
html {
  height: auto !important;
}

@keyframes btn-breathe {
  0% {
    transform: scale(1) translateX(-50%);
  }

  50% {
    transform: scale(1.2) translateX(-50%)
  }

  100% {

    transform: scale(1) translateX(-50%)
  }
}
  </style>
  